<template>
  <article class="m-card-element m-card-element-design-6">
    <img
      v-if="producto.metadata.imagen"
      :alt="producto.nombre"
      id="tarjetaImagen"
      :src="producto.metadata.imagen"
    >
    <img
      v-else
      :alt="producto.nombre"
      id="tarjetaImagen"
      src="@/assets/img/ds6.png"
    >
    <div class="m-card-element-info-data">
      <h5>
        {{ producto.categoria.nombre }}
      </h5>
      <h2 class="m-card-element-design-6-name">
        {{ producto.nombre }}
      </h2>
    </div>
    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="producto.activo"
          key="available"
        >
          DISPONIBLE
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          NO DISPONIBLE
        </h3>
        <h4
          v-if="producto.visible"
          key="visible"
        >
          VISIBLE
        </h4>
        <h4
          v-else
          key="hidden"
        >
          OCULTO
        </h4>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyProductCard6',
  props: {
    producto: Object
  }
}
</script>
